<div
    class="modal-header modal-header-md relative"
    [ngClass]="{
        block: mode === 'BLOCK',
        advise: mode === 'ADVISE',
        pass: mode === 'PASS'
    }"
>
    <div
        class="information-icon"
        [ngClass]="{
            'block-icon': mode === 'BLOCK',
            'advise-icon': mode === 'ADVISE',
            'pass-icon': mode === 'PASS'
        }"
    >
        <span *ngIf="mode === 'ADVISE'" class="fa fa-exclamation"></span>
        <span *ngIf="mode === 'BLOCK'" class="fad fa-times"></span>
        <span *ngIf="mode === 'PASS'" class="fad fa-check"></span>
    </div>
    <h4
        class="modal-title modal-title-md"
        [ngClass]="{
            block: mode === 'BLOCK',
            advise: mode === 'ADVISE',
            pass: mode === 'PASS'
        }"
    >
        {{ mode }}: {{ modalTitle }}
    </h4>
</div>
<div class="modal-body information-modal">
    <ng-container *ngIf="guidanceMessage">
        <label> Guidance to Operators </label>
        <div
            class="bottom-buffer pre-line"
            [innerHTML]="guidanceMessage | autolink"
        ></div>
    </ng-container>
    <div class="vertical-container">
        <div *ngIf="hasReasons()" class="vertical-container">
            <label>Active Hours on Day of Operation</label>
            <ng-container *ngFor="let rule of ruleOutcomes; let i = index">
                <ng-container *ngFor="let reason of rule.reason">
                    <div
                        class="horizontal-container information-block vertical-align"
                        [ngClass]="{
                            blocks: mode === 'BLOCK',
                            advises: mode === 'ADVISE',
                            passes: mode === 'PASS'
                        }"
                    >
                        <div
                            class="index-number"
                            [ngClass]="{
                                block: mode === 'BLOCK',
                                advise: mode === 'ADVISE',
                                pass: mode === 'PASS'
                            }"
                        >
                            {{ i + 1 }}
                        </div>
                        <div>
                            <span *ngIf="reason?.identifier != null"
                                ><strong>{{ reason?.identifier }}</strong>
                                {{ reason?.name }}</span
                            >
                            <span *ngIf="reason?.identifier == null"
                                ><strong>{{ reason?.name }}</strong></span
                            >
                            <!-- <span
                        >{{ returnRuleType(rule) }}&nbsp;&nbsp;<strong>{{
                            rule.reason[0]?.identifier
                        }}</strong
                        >&nbsp;{{ rule.reason[0]?.name }}</span
                    > -->
                            <div
                                *ngIf="rule.reason[0]?.state"
                                class="airspace-status-indicator"
                                [ngClass]="{
                                    block:
                                        rule.reason[0].state === 'ACTIVATED' &&
                                        mode === 'BLOCK',
                                    advise:
                                        rule.reason[0].state === 'ACTIVATED' &&
                                        mode === 'ADVISE',
                                    pass:
                                        rule.reason[0].state === 'ACTIVATED' &&
                                        mode === 'PASS',
                                    inactive:
                                        rule.reason[0].state !== 'ACTIVATED'
                                }"
                            >
                                {{ reasonStateDisplay[rule.reason[0].state] }}
                            </div>
                            <div
                                *ngIf="reason.message"
                                class="pre-wrap"
                                [textContent]="reason.message"
                            ></div>
                            <table
                                *ngIf="
                                    reason.activeHours != null &&
                                    reason.activeHours.length > 0
                                "
                                class="table"
                                style="margin-bottom: 0"
                            >
                                <tbody>
                                    <tr
                                        *ngFor="let hours of reason.activeHours"
                                    >
                                        <td>
                                            {{
                                                hours.activeFrom
                                                    | formatTimestamp
                                            }}
                                            <span *ngIf="timeZone != null"
                                                ><br />({{
                                                    hours.activeFrom
                                                        | formatDateTimeUniversal
                                                            : timeZone
                                                }})</span
                                            >
                                        </td>
                                        <td>TO</td>
                                        <td>
                                            {{
                                                hours.activeTo | formatTimestamp
                                            }}
                                            <span *ngIf="timeZone != null"
                                                ><br />({{
                                                    hours.activeTo
                                                        | formatDateTimeUniversal
                                                            : timeZone
                                                }})</span
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
        <div
            *ngIf="
                (message?.regulatorDescription &&
                    message.regulatorDescription.length) ||
                (message?.additionalInformationUrl &&
                    message.additionalInformationUrl.length > 0)
            "
            class="vertical-container fill"
        >
            <div
                *ngIf="
                    message?.regulatorDescription &&
                    message.regulatorDescription.length
                "
            >
                <label> Further Information </label>
                <p class="pre-line">
                    {{ message.regulatorDescription }}
                </p>
            </div>
            <div
                *ngIf="
                    message.additionalInformationUrl &&
                    message.additionalInformationUrl.length > 0
                "
            >
                <a [href]="message.additionalInformationUrl" target="_blank">
                    Read more
                </a>
            </div>
        </div>
        <div
            *ngIf="
                !hasReasons() &&
                (!message?.regulatorDescription ||
                    !message.regulatorDescription.length)
            "
            class="vertical-container fill"
        >
            <span class="fa fa-sparkles sparkle"></span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <!-- <button
        type="button"
        class="btn btn-default pull-left"
        (click)="viewRule()"
    >
        View Rule
    </button> -->
    <button
        type="button"
        class="btn"
        [ngClass]="{
            block: mode === 'BLOCK',
            advise: mode === 'ADVISE',
            pass: mode === 'PASS'
        }"
        (click)="close()"
    >
        OK
    </button>
    <inline-modal
        #inlineModal
        [sizeSmall]="true"
        style="max-height: fit-content"
    ></inline-modal>
</div>
